import { EExerciseType, TExerciseItem } from "types/app/exercises";

export const recordAudioExercise: TExerciseItem = {
  title: "Запис аудіо",
  backgroundText: "Запис аудіо",
  tags: ["Запис аудіо", "запис", "аудіо", "audio", "record", "voice"],
  type: EExerciseType.RECORD_AUDIO,
  cover: "record-audio.png",
};
